import { GUID, Nullable } from '@/types/common.types';
import { UserTypes } from '@/utils/enums/Roles';
import { getAccessToken } from '@/services/axios-instance';
import { LanguagesEnum } from '@/utils/enums/Languages';
import { StatusOptionsEnum } from '../enums/StatusOptions';

export interface IParseJwtReturn {
  exp: number;
  id: GUID;
  organizationID: GUID;
  studentInfo: Nullable<IStudentInfo>;
  userType: UserTypes;
  username: string;
  lang: LanguagesEnum;
  packageType?: 'gold' | 'bronze';
}

export interface IStudentInfo {
  studentID: GUID;
  gradeID: GUID;
  classID: GUID;
  status?: StatusOptionsEnum;
}

export const parseAuthToken = (token: string): IParseJwtReturn => {
  const base64Url = token?.split('.')[1];

  const base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/');
  if (base64) {
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );

    return JSON.parse(jsonPayload);
  }
  return {
    exp: 0,
    id: '',
    organizationID: '',
    studentInfo: null,
    userType: UserTypes.STUDENT,
    username: '',
    lang: LanguagesEnum.Turkish,
  };
};

export const getUserType = () => {
  const token = getAccessToken();
  if (!token) return UserTypes.STUDENT;
  const { userType } = parseAuthToken(token);
  return userType as UserTypes;
};

export const getUserStatus = () => {
  const token = getAccessToken();
  if (!token) return null;
  const { studentInfo } = parseAuthToken(token);
  if (!studentInfo) return null;
  return studentInfo?.status as StatusOptionsEnum;
};

export const getPackageTypeFromToken = ():
  | 'gold'
  | 'institutional'
  | 'bronze' => {
  const token = getAccessToken();
  if (!token) return 'institutional';

  const { userType, packageType } = parseAuthToken(token);

  if (userType === UserTypes.STUDENT) {
    return 'institutional';
  }

  if (userType === UserTypes.INDIVIDUAL && packageType) {
    return packageType;
  }

  return 'institutional';
};
